//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "FaqThemesDetails",
    props: {
        items: {
            type: Array,
            default: () => ([])
        }
    },
}
